export default __webpack_public_path__ + "static/media/overviewPic-CN.53e3549c.png";